import { defineStore } from 'pinia'
import { ref } from 'vue'

/** Prefisso delle chiavi in sessionStorage (una per utente e pagina). */
export const PREFISSO_FILTRI = 'filtri-lista:'

/**
 * Filtri delle liste, tenuti IN MEMORIA per chiave «utente:pagina» (vedi `useFiltriLista`).
 * Vivono quanto la sessione dell'app: si svuotano al logout e al cambio di persona (passpartout).
 * Mai su localStorage: il testo cercato può contenere nomi di persone.
 */
export const useFiltriListaStore = defineStore('filtriLista', () => {
  const valori = ref<Record<string, unknown>>({})

  function leggi<T>(chiave: string): T | undefined {
    return valori.value[chiave] as T | undefined
  }

  function scrivi(chiave: string, valore: unknown): void {
    // copia profonda: lo stato della lista continua a cambiare, il salvato no
    valori.value[chiave] = JSON.parse(JSON.stringify(valore))
  }

  /** Dimentica tutto: memoria e sessionStorage. */
  function svuota(): void {
    valori.value = {}
    try {
      const da: string[] = []
      for (let i = 0; i < sessionStorage.length; i++) {
        const k = sessionStorage.key(i)
        if (k && k.startsWith(PREFISSO_FILTRI)) da.push(k)
      }
      da.forEach((k) => sessionStorage.removeItem(k))
    } catch { /* sessionStorage non disponibile: resta solo la memoria, già svuotata */ }
  }

  return { valori, leggi, scrivi, svuota }
})
